import classNames from 'classnames'
import { type Dispatch, type SetStateAction } from 'react'

import { Icon } from '@/shared'
import { type ISwapSequencs } from '@App/types/common'
import { EIcons } from '@App/types/iconType'
import {
    type ICategoryDto,
    type IChildServiceDec,
    type IServiceDec,
    type TMainCategoryData
} from '@App/types/servicesTypes'
import { OTHERS_CATEGORY_ID } from '@Config/config'

import { Sections } from '../Sections/Sections'
import { Services } from '../Services/Services'

import style from './CategoryItem.module.scss'
import { EmptyList } from './EmptyList/EmptyList'
import { NameTitle } from './NameTitle/NameTitle'

interface IProps {
    chosen: string | null
    item: IServiceDec
    editableCategory: TMainCategoryData | null
    // adminRoles?: IRole[]
    highlited: string | null
    onSwapServices: (dto: ISwapSequencs) => void
    onSwapCategories: (dto: ISwapSequencs) => void
    onGetSectionsRules: (id: string) => void
    setAddSectionId: (addSectionId: string | null) => void
    setChosen: (chosen: string | null) => void
    setRemovableCategory: (removableCategory: TMainCategoryData | null) => void
    setEditableCategory: Dispatch<SetStateAction<TMainCategoryData | null>>
    onSetTranferSevice: (tranferSevice: IChildServiceDec | null) => void
    onEditCategory: (dto: ICategoryDto, onSuccess: () => void) => void
    onAddSection: (dto: ICategoryDto, onSuccess: () => void) => void
    onRemoveSection: (id: string, onSuccess: () => void) => void
    onEditSection: (dto: ICategoryDto, onSuccess: () => void) => void
    onDragStartHandler: (e: any, item: IServiceDec) => void
    onDragLeaveHandler: (e: any, id: string) => void
    onDragEndHandler: (e: any) => void
    onDragOverHandler: (e: any, id: string) => void
    onDropHandler: (e: any, item: IServiceDec) => void
}

export const CategoryItem = (props: IProps) => {
    const {
        item,
        editableCategory,
        chosen,
        // adminRoles,
        highlited,
        onSwapServices,
        onSwapCategories,
        onGetSectionsRules,
        setAddSectionId,
        setEditableCategory,
        setChosen,
        onSetTranferSevice,
        onEditCategory,
        onAddSection,
        onRemoveSection,
        onEditSection,
        onDragEndHandler,
        onDragLeaveHandler,
        onDragOverHandler,
        onDragStartHandler,
        onDropHandler
    } = props

    const { name, childCategories, childServices, id } = item

    const isEdit = (editableCategory && editableCategory.id === id) || false
    const containerCn = classNames(
        style.container,
        !chosen && highlited === id && style.highlitedContainer,
        isEdit && style.editableItemContainer
    )

    const onSetChosenCategory = () => {
        if (chosen && chosen === id) {
            setChosen(null)
        } else {
            setChosen(id)
        }
    }
    const onSaveEditedCategory = () => {
        if (editableCategory?.name) {
            const dto: ICategoryDto = {
                parentId: null,
                id,
                name: editableCategory.name,
                isBarsFiltering: false,
                preparingDescription: null,
                exceptionRules: [],
                permissionRules: []
            }
            onEditCategory(dto, () => setChosen(null))
        }
    }

    const onGetCategoryRulesHandler = () => {
        onGetSectionsRules(id)
    }

    // const onEditItem = () => {
    //     if (editableCategory) {
    //         setEditableCategory(null)
    //     } else {
    //         setEditableCategory({ id, name })
    //     }
    // }

    // const onRemoveCategory = () => {
    //     setRemovableCategory({ id, name })
    // }

    const onRenderCategories = () => {
        switch (true) {
            case childCategories.length > 0:
                return (
                    <Sections
                        // adminRoles={adminRoles}
                        sections={childCategories}
                        parentName={name}
                        parentId={id}
                        onSwapServices={onSwapServices}
                        onSwapCategories={onSwapCategories}
                        onGetSectionsRules={onGetSectionsRules}
                        onSetTranferSevice={onSetTranferSevice}
                        setAddSectionId={setAddSectionId}
                        onRemoveSection={onRemoveSection}
                        onEditSection={onEditSection}
                        onAddSection={onAddSection}
                    />
                )
            case childServices.length > 0:
                return (
                    <Services
                        onSwapServices={onSwapServices}
                        isDraggable={id !== OTHERS_CATEGORY_ID}
                        services={childServices}
                        parentName={name}
                        parentId={id}
                        onSetTranferSevice={onSetTranferSevice}
                    />
                )
            default:
                return <EmptyList categoryId={id} categoryName={name} setAddSectionId={setAddSectionId} />
        }
    }

    return (
        <div
            className={containerCn}
            onDragStart={(e: any) => onDragStartHandler(e, item)}
            onDragLeave={(e: any) => onDragLeaveHandler(e, id)}
            onDragEnd={onDragEndHandler}
            onDragOver={(e: any) => onDragOverHandler(e, id)}
            onDrop={(e: any) => onDropHandler(e, item)}
            draggable={!chosen}
        >
            <div className={style.categoryItem}>
                <NameTitle
                    isEdit={isEdit}
                    name={name}
                    editableCategory={editableCategory}
                    setEditableCategory={setEditableCategory}
                />
                {isEdit && (
                    <div className={style.saveIconWrapper} onClick={onSaveEditedCategory}>
                        <Icon iconName={EIcons.PLUS} color='#007DEE' />
                    </div>
                )}
                {/* {!isEdit && (
                    <div className={style.removeIconWrapper} onClick={onRemoveCategory}>
                        <div>
                            <Icon iconName={EIcons.TRSH2} color='#007DEE' />
                        </div>
                    </div>
                )} */}
                {/* <div className={style.editIconWrapper} onClick={onEditItem}>
                    <div>
                        <Icon iconName={isEdit ? EIcons.CLOS : EIcons.PEN} color='#007DEE' />
                    </div>
                </div> */}
                {!isEdit && (
                    <div className={style.noteIcon} onClick={onGetCategoryRulesHandler}>
                        <div>
                            <Icon iconName={EIcons.Note} color='#007DEE' />
                        </div>
                    </div>
                )}
                {!isEdit && (
                    <div className={style.arrowIconWrapper} onClick={onSetChosenCategory}>
                        <div className={classNames(style.icon, chosen === id && style.activeIcon)}>
                            <Icon iconName={EIcons.AROW} />
                        </div>
                    </div>
                )}
            </div>
            {chosen === id && onRenderCategories()}
        </div>
    )
}
